import React from 'react';
import { observer, inject } from 'mobx-react';

import { getChildInject } from '@/utils/instantLoaded/tools';
import botAvatarImage from '@/assets/img/chatbot_avatar@2x.png';
import defaultUserAvatarImage from '@/assets/img/avatar@2x.png';

import './style.scss';

interface Props {
  from: string;
  agentAvatar?: string;
  botAvatar?: string;
  userAvatar?: string;
  userStore?: any;
  firstInit?: any;
}

const Avatar = inject(getChildInject('userStore', 'firstInit'))(
  observer((props: Props) => {
    const {
      from,
      agentAvatar,
      botAvatar,
      userAvatar,
      userStore,

      firstInit,
    } = props;

    const generateImg = () => {
      switch (from) {
        case 'agent':
          return <img src={agentAvatar || firstInit.initStore.agentAvatar || ''} />;
        case 'user':
          return <img src={userAvatar || userStore.userAvatar || defaultUserAvatarImage} />;
        case 'bot':
        default:
          return <img src={botAvatar || firstInit.initStore.botAvatar || botAvatarImage} />;
      }
    };

    return (
      <div className="avatar">
        {generateImg()}
      </div>
    );
  }),
);

export default Avatar;
